import apiDealerService from "@/services/api/modules/dealerService";

export default {
  async getDealers({ commit }, page = {}) {
    commit("SET_DEALERS", []);
    const { status, data } = await apiDealerService.getDealers(
      page.page,
      page.per_page,
      page.q,
    );

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );
    } else {
      let responseData = Object.keys(page).length === 0 ? data.data : data;

      commit("SET_DEALERS", responseData);
    }
  },
  async getDealer({ commit }, id) {
    commit("SET_DEALER", null);
    const { status, data } = await apiDealerService.getDealer(id);

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );
    } else {
      commit("SET_DEALER", data.data);
    }
  },
  async save({ dispatch, commit }, details) {
    if (details.id) {
      var { status, data } = await apiDealerService.update(details.id, details.data);
    } else {
      var { status, data } = await apiDealerService.create(details.data);
    }

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );
    } else {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );

      commit("SET_DEALER", data.data);
    }
  },
  async delete({ dispatch }, id) {
    const { status, data } = await apiDealerService.delete(id);

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );
    } else {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );
      dispatch("getItems");
    }
  },
};
